// extracted by mini-css-extract-plugin
export default {"slideContainer":"_516d0b9dd9 _79d37bafa6 _7bc75a17df","slideImage":"_48c2cb1bf8"};